import Blue from "~/core";

new Blue({
	name: 'Mobile Nav',
	selector: ".header-nav",
	setup(nav) {
        const navToggle = document.querySelector('.js-mobile-nav')
        const navMobileToggle = document.querySelector('.js-mobile-nav-close')
        const navInner = document.querySelector('.header-nav__inner')
        let currentFocus

        this.$addEvents(navToggle, 'click', function() {
            const initialFocus = navInner.childNodes[0]
            currentFocus = document.activeElement
            navInner.classList.toggle('is-open')
            navInner.toggleAttribute('aria-expanded')
            
            // basic focus trap
            navInner.addEventListener('focusout', () => {
                if (!navInner.matches(':focus-within')) {
                    initialFocus.focus()
                }
            })
            createScrim()
        })
        this.$addEvents(navMobileToggle, 'click', function() {
            navInner.classList.toggle('is-open')
            navInner.toggleAttribute('aria-expanded')
            currentFocus.focus()
            destroyScrim()
        })


        function navAttributes (element) {
            element.classList.toggle('is-open')
            element.toggleAttribute('aria-expanded')
            element.toggleAttribute('aria-hidden') 
        }
        
        function createScrim () {
            let scrimTest = document.getElementById('js-scrim')
            if(!scrimTest) {
                let scrim = document.createElement('div')
                scrim.id = 'js-scrim'
                scrim.classList.add('header-nav__scrim', 'is-open')
                document.body.appendChild(scrim)
                document.body.classList.add('scrim-is-open')
                listenScrim()
            }
          }
        function destroyScrim () {
            let scrim = document.getElementById('js-scrim')
            if(scrim){
                scrim.parentNode.removeChild(scrim)
                document.body.classList.remove('scrim-is-open')
            }
        }
        function listenScrim () {
            let scrim = document.getElementById('js-scrim')
            if(scrim){
                scrim.addEventListener('click', function () { 
                    navInner.classList.toggle('is-open')
                    navInner.toggleAttribute('aria-expanded')
                    
                    
                    destroyScrim()
                })
            }
          }
	}
});